import {request, setAuthInHeader} from "@/api/request";
import util from "@/mixins/util";
import {logout, getTokenObj} from "@/mixins/Auth";
import {isDev} from "@/api/config";

const state = {
    UserInfo: {},
};

const getters = {
    getUserInfo: state => state.UserInfo,

};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },
};

const actions = {
    setUserInfo({commit, rootState}, {token}) {
        setAuthInHeader(token);
        let tokenObj = getTokenObj();
        let params = {}
        try {
            request.javaGet('v1/member/WEB/info', params).then(({data}) => data)
                .then((res) => {
                    if (!res) {
                        return false;
                    }
                    let result = res.result;

                    if (res.code > 0 && !util.isEmpty(result.data)) {
                        commit('updateUserInfo', {'value': result.data});
                    } else {
                        commit('updateUserInfo', {'value': {}})
                        logout();
                    }
                }, () => {
                    console.log('error');
                    logout();
                })
        } catch (e) {
            console.log(e);
            logout();
        }
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
